import React from "react";
import { useNavigate } from "react-router-dom";

export const Footer = (props) => {
  const navigate = useNavigate();

  const handleFooterNavClick = (hash) => (e) => {
    e.preventDefault();
    navigate({ pathname: "/", hash });
    setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div id="footer" className="footer-modern">
      <div className="container">
        <div className="row gy-4">
          <div className="col-md-4">
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <img src={`${process.env.PUBLIC_URL}/img/kovid/kovid-logo.png`} alt="Kovid India" style={{ height: '30px', width: 'auto', marginRight: '10px' }} />
              <h5 className="footer-title">Kovid India</h5>
            </div>
            <p className="footer-text">
              Providing high-quality electronic components, RF solutions,
              testing systems and industrial tools across India.
            </p>
          </div>

          <div className="col-md-2">
            <h6 className="footer-heading">Company</h6>
            <ul className="footer-links">
              <li>
                <a href="/#services" onClick={handleFooterNavClick("#services")}>
                  Services
                </a>
              </li>
              <li>
                <a href="/#about" onClick={handleFooterNavClick("#about")}>
                  About
                </a>
              </li>
              <li>
                <a href="/#contact" onClick={handleFooterNavClick("#contact")}>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="col-md-3">
            <h6 className="footer-heading">Contact</h6>
            <p className="footer-text mb-1">{props.data?.email || "info@kovidindia.com"}</p>
            <p className="footer-text">{props.data?.phone || "+91 XXXXX XXXXX"}</p>
          </div>

          <div className="col-md-3 text-md-end">
            <h6 className="footer-heading">Follow Us</h6>
            <div className="footer-social">
              <a href={"/#page-top"}>
                <i className="fa fa-facebook"></i>
              </a>
              <a href={"/#page-top"}>
                <i className="fa fa-twitter"></i>
              </a>
              <a href={"/#page-top"}>
                <i className="fa fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="text-center small">
          © {new Date().getFullYear()} Kovid India. All Rights Reserved.
        </div>
      </div>
    </div>
  );
};
